import styled from 'styled-components';
import Checkbox from '~/src/components/form-components/checkbox/checkbox';

export const SelfEmployedCheckbox = styled(Checkbox)`
    width: 100%;
`;
